export enum InventoryItemNature {
  Consumable = 1,
  Returnable = 2,
}

export enum InventoryChargeToKind {
  CostCenter = 1,
  Machine = 2,
  WorkOrder = 3,
}

export enum InventoryMovementKind {
  Receipt = 1,
  Issue = 2,
  Assign = 3,
  Return = 4,
  TransferOut = 5,
  TransferIn = 6,
  Adjustment = 7,
  CountCorrection = 8,
  VendorReturn = 9,
}

export enum InventoryMovementClass {
  Active = 1,
  Slow = 2,
  Obsolete = 3,
}

export enum InventoryReservationSource {
  Request = 1,
  WorkOrder = 2,
  Manual = 3,
}

export enum InventoryReservationStatus {
  Active = 1,
  Consumed = 2,
  Released = 3,
}

export enum InventoryAdjustmentReason {
  Damage = 1,
  Theft = 2,
  CountVariance = 3,
  Waste = 4,
  Expiry = 5,
}

export enum InventoryAdjustmentStatus {
  Open = 1,
  Posted = 2,
}

export enum InventoryTransferStatus {
  Draft = 1,
  Dispatched = 2,
  InTransit = 3,
  Received = 4,
}

export enum InventoryReceiptQcResult {
  Pass = 1,
  Rejected = 2,
  Pending = 3,
}

export enum InventoryStockTakeStatus {
  Scheduled = 1,
  InProgress = 2,
  AwaitingApproval = 3,
  Completed = 4,
}

export enum InventoryStockTakeApprovalRole {
  InventoryManager = 1,
  Supervisor = 2,
}

export enum InventoryCustodyStatus {
  Ok = 1,
  Overdue = 2,
  Returned = 3,
}

export enum InventoryCountCadence {
  Weekly = 1,
  Monthly = 2,
  Quarterly = 3,
}

export enum InventoryCountScheduleState {
  Ok = 1,
  Counting = 2,
  Overdue = 3,
}

export enum InventoryVendorReturnStatus {
  Draft = 1,
  Sent = 2,
  Credited = 3,
  Replaced = 4,
}

export enum InventoryVendorReturnReason {
  QcReject = 1,
  ShortShip = 2,
  Warranty = 3,
}
